import { render, staticRenderFns } from "./EmailSendLimit.vue?vue&type=template&id=5ef25d49&scoped=true"
import script from "./EmailSendLimit.vue?vue&type=script&lang=js"
export * from "./EmailSendLimit.vue?vue&type=script&lang=js"
import style0 from "./EmailSendLimit.vue?vue&type=style&index=0&id=5ef25d49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef25d49",
  null
  
)

export default component.exports